import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Observable, catchError, map, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoginGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): boolean | UrlTree | Observable<boolean | UrlTree> {
    if (this.authService.isLogoutInProgress() || this.authService.isTabSessionInvalidated()) {
      return true;
    }

    if (this.authService.getParsedLoginData()) {
      return this.router.createUrlTree(['/syncinns-pms']);
    }

    return this.authService.restoreLoginDataFromProfile({ skipAuthRefresh: true }).pipe(
      map(() => this.router.createUrlTree(['/syncinns-pms'])),
      catchError(() => of(true)),
    );
  }
}
